/* global module clearTimeout setTimeout window*/

import React from 'react';
import { connect } from 'react-redux';
import { startCase, pick, range, flatten } from 'lodash';
import { bindActionCreators } from 'redux';
import Slider from '../../common/Slider/index.tsx';
import NavButtons from '../../common/NavButtons.tsx';
import Help from '../../common/Help';
import InputLocation from './InputLocation';
import { withT, wrap } from '../../../lib/wrappers';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import ResizableComponent from '../../../lib/base_classes/ResizableComponent';

const householdIncomeLabels = (t) => {
  if (window.innerWidth < 400) {
    return [
      startCase(t('avg')), null,
      ...flatten([30, 50, 80, 120 ].map(amount => [t('{{amount}}k', { amount }), null])),
      `${t('{{amount}}k', { amount: '200' })}+`,
    ];
  }
  return [
    startCase(t('avg')),
    t('<{{amount}}k', { amount: '20' }),
    ...range(30, 60, 10).map(amount => t('{{amount}}k', { amount })),
    ...range(60, 130, 20).map(amount => t('{{amount}}k', { amount })),    
    `${t('{{amount}}k', { amount: '150' })}`,
    `${t('{{amount}}k', { amount: '200' })}+`,
  ];
};


class GetStartedComponent extends ResizableComponent {

  constructor(props, context) {
    super(props, context);
    this.initResizeListener();
    this.state = { width: window.innerWidth };
  }

  resize() {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const { t, computeAverageFootprint } = this.props;
    const householdSizeLabels = [t('2.5 (avg.)'), '1', '2', '3', '4', '5+'];
    return (
      <div className="cc-component" id="get_started">
        <header className="cc-component__header">
          <span className="cc-component__byline" dangerouslySetInnerHTML={{ __html: this.props.t('Start with a quick carbon footprint estimate') }} />
        </header>

        <div className="cc-component__form">
          <InputLocation />

          <div className="cc-component__question">
            <h4>
              2. {this.props.t('How many people live in your household?')}
              <Help
                popoverProps={{ id: 'household_size_help' }}
                helpText={this.props.t('Enter the total number of adults and children in your household. If you only want to calculate your personal carbon footprint, then select 1 and enter your personal consumption in the calculator, such as just your share of energy bills or driving.')}
              />
            </h4>
            <Slider
              id="get_started__household_size"
              min={0}
              max={5}
              step={1}
              ticks={6}
              labels={householdSizeLabels}
              value={this.props.inputSize}
              onChange={value => computeAverageFootprint({ input_size: value })}
            />
            <div className="cc-slider-container" id="size_slider" />
          </div>
          <div className="cc-component__question">
            <h4>
              3. {this.props.t('What is your gross annual household income?')}
              <Help
                popoverProps={{ id: 'household_income_help' }}
                helpText={this.props.t('Entering income helps the calculator provide appropriate default values and a comparison to similar households. This information is private even for users that share their profile publicly.')}
              />
            </h4>
            <Slider
              id="get_started__household_income"
              min={1}
              max={11}
              ticks={11}
              labels={householdIncomeLabels(t)}
              value={this.props.inputIncome}
              onChange={value => computeAverageFootprint({ input_income: value })}
            />
          </div>
        </div>
        <NavButtons ui={this.props.ui} />
      </div>
    );
  }

}

const mapStateToProps = state => [
  'inputIncome',
  'inputSize',
  'user_footprint',
  'average_footprint',
  'ui',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'computeAverageFootprint',
  ]),
  dispatch,
);

export default wrap(
  withT('getStarted'),
  connect(mapStateToProps, mapDispatchToProps),
  GetStartedComponent,
);
